var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_33",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m31.693,66.131c-.129-1.339.048-2.647.509-3.872,3.702-.605,6.744-3.171,8.028-6.598,1.285,3.427,4.326,5.993,8.028,6.598.363.964.55,1.98.55,3.022,0,5.075-4.43,9.135-9.626,8.516-3.94-.469-7.108-3.717-7.49-7.666Zm18.307-23.562c1.242,3.511,4.318,6.152,8.075,6.774.486,1.47.583,3.048.212,4.644-.783,3.371-3.594,6.007-7.015,6.526-5.32.808-9.916-3.307-9.916-8.477,0-.915.149-1.812.431-2.673,3.82-.579,6.956-3.242,8.213-6.795Zm8.317-11.904c5.861-.968,10.88,4.051,9.912,9.912-.586,3.551-3.45,6.416-7.001,7.004-5.864.971-10.886-4.051-9.915-9.915.588-3.551,3.453-6.415,7.004-7.001Zm-8.317,54.828c-4.73,0-8.578-3.848-8.578-8.578,0-.456.046-.908.117-1.354,3.932-.498,7.177-3.203,8.461-6.833,1.285,3.631,4.53,6.336,8.463,6.834.071.447.115.899.115,1.353,0,4.73-3.848,8.578-8.578,8.578Zm9.559-11.635c-4.525-.109-8.285-3.899-8.366-8.425-.02-1.106.178-2.178.565-3.195,3.699-.66,6.718-3.284,7.946-6.755,1.244,3.516,4.327,6.16,8.093,6.777.364.964.552,1.98.552,3.022,0,4.8-3.963,8.692-8.79,8.576Zm9.916-30.399c4.813,0,8.713,3.984,8.575,8.828-.127,4.472-3.856,8.199-8.328,8.326-4.843.137-8.826-3.763-8.826-8.575,0-.916.15-1.812.431-2.673,3.514-.533,6.451-2.828,7.878-5.96.086.028.174.054.269.054Zm-23.719-13.099c-1.75-1.173-3.92-1.735-6.211-1.585-3.782.247-7.08,2.704-8.706,6.127-1.157,2.436-1.175,4.717-.648,6.781-5.563.178-10.037,4.748-10.037,10.354s4.515,10.22,10.114,10.358c-.27.934-.41,1.901-.41,2.887,0,5.546,4.379,10.075,9.859,10.345-.053.426-.089.856-.089,1.288,0,5.719,4.652,10.371,10.371,10.371s10.371-4.652,10.371-10.371c0-.431-.036-.861-.089-1.288,5.48-.269,9.86-4.799,9.86-10.345,0-.986-.138-1.953-.409-2.887,5.599-.139,10.113-4.726,10.113-10.358s-4.474-10.176-10.037-10.354c.209-.82.333-1.675.333-2.56,0-.898-.132-1.792-.39-2.652l-.076-.254c-.239-.799-.531-1.586-.951-2.306-1.799-3.082-5.136-5.159-8.955-5.159-.778,0-1.535.087-2.264.251-1.639.37-3.131,1.221-4.404,2.317l-.033.029c-1.154.993-2.149,2.184-2.768,3.575-.11.246-.21.497-.3.753-.34-.962-.812-1.861-1.403-2.67h0c-.775-.995-1.682-1.87-2.841-2.647Zm-6.981.305c5.861-.969,10.881,4.05,9.913,9.912-.586,3.551-3.45,6.416-7.002,7.004-5.863.97-10.884-4.051-9.914-9.914.588-3.551,3.452-6.415,7.003-7.002Zm-7.956,12.799l.007.005c1.438,3.099,4.357,5.367,7.847,5.896.48,1.462.574,3.032.206,4.621-.78,3.368-3.587,6.003-7.004,6.527-5.325.817-9.928-3.302-9.928-8.475,0-4.827,4.008-8.736,8.872-8.573Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m66.237,13.976c-17.594,0-16.211,14.967-16.211,14.967l.071,7.677",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m34.793,8.687h1.656c5.802,0,10.512,4.71,10.512,10.512v1.656h-1.656c-5.802,0-10.512-4.71-10.512-10.512v-1.656h0Z",
          transform: "translate(83.572 22.906) rotate(170.921)",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }